import {
  handleLocationSelectBySwitch,
  handleMachineSelectBySwitch,
  handleSelectAllBySwitch,
  handleSpecificLocationSelectBySwitch,
} from '../../../components/store/slices/masterControlBySwitchSelectSlice';
import {
  handleLocationSelectByLocation,
  handleMachineSelectByLocation,
  handleSelectAllByLocation,
  handleSpecificLocationSelectByLocation,
} from '../../../components/store/slices/masterControlSelectByLocationSlice';

export const selectAllDispatchHandler = (
  dispatch,
  scope,
  name,
  locationList,
  specificLocationList,
  machineList,
  select = true
) => {
  if (scope === 'switch') {
    dispatch(handleSelectAllBySwitch({ controller: name, status: select }));
    dispatch(handleLocationSelectBySwitch(locationList));
    dispatch(handleSpecificLocationSelectBySwitch(specificLocationList));
    dispatch(handleMachineSelectBySwitch(machineList));
  } else {
    dispatch(handleSelectAllByLocation({ controller: name, status: select }));
    dispatch(handleLocationSelectByLocation(locationList));
    dispatch(handleSpecificLocationSelectByLocation(specificLocationList));
    dispatch(handleMachineSelectByLocation(machineList));
  }
};
